module.exports = __webpack_public_path__ + "static/media/smartphones4.1c32b076.png";